

export default {
    appShell: {
    "menuLabels": [
        "市場ツール",
        "先物ツール",
        "チェーン探索",
        "ニュース分類"
    ],
    "closeMenu": "メニューを閉じる",
    "menuDescriptions": {
        "collect": "保存した通貨を追跡",
        "platform": "取引所ランキングと出来高",
        "toolOutsidePrice": "店頭取引価格を比較",
        "toolOutsideDisk": "世界の市場動向を確認",
        "toolSentimentIndex": "恐怖・強欲指数を確認",
        "manyEmpty": "ロング・ショートの比率",
        "hyperliquid": "Hyperliquidのクジラポジションを監視",
        "rate": "取引所の資金調達率を比較",
        "toolLargeIncrease": "大口のポジション増加",
        "toolLargeDecrease": "大口のポジション減少",
        "newChain": "新規トークンを探索",
        "whale": "大口・機関の保有状況",
        "trace": "保存したアドレスを追跡",
        "inscription": "インスクリプション市場",
        "toolStableCoin": "供給量・プレミアム・発行",
        "toolCompanyHoldings": "企業のBTC保有量",
        "toolMTGoxMonitor": "Mt. Goxの送金を確認",
        "toolBlockChainBrowser": "各チェーンのエクスプローラー",
        "calendar": "主要経済イベントの日程",
        "forum": "コミュニティの投稿と議論",
        "application": "市場のアプリとリソース"
    }
,
    "back": "戻る",
    "switchPage": "ページ",
    "collapse": "閉じる",
    "intro": "価格・市場心理・資金の動き。",
    "home": "TokenTrend ホーム",
    "externalLink": "外部サイト",
    "openExternal": "サイトを開く",
    "externalBridgeHint": "TokenTrend を離れて外部サイトを開きます。開いた後は左端からスワイプで戻れます。",
    "light": "ライトモード",
    "dark": "ダークモード",
    "search": "トークンを検索",
    "closeSearch": "検索を閉じる",
    "brandTagline": "価格 · 心理 · 資金",
    "greetingMorning": "おはようございます、",
    "greetingAfternoon": "こんにちは、",
    "greetingEvening": "こんばんは、",
    "darkModeLabel": "ダークモード",
    "appearance": "外観",
    "themeLight": "ライト",
    "themeDark": "ダーク",
    "notifications": "通知",
    "closeNotifications": "通知を閉じる",
    "notifySample": [
        { "title": "ビットコインは $77,000 を維持", "body": "夜間取引後も BTC は安定しています。" },
        { "title": "資金調達率は均衡", "body": "主要取引所は中立圏にあります。" },
        { "title": "市場心理は中立", "body": "恐怖・強欲指数はレンジの中ほどです。" }
    ],
    "workspace": "マーケット",
    "categories": "ページ分類",
    "navigation": "メインナビゲーション",
    "groups": [
        "市場",
        "先物",
        "オンチェーン",
        "ニュース",
        "アカウント"
    ],
    "pages": {
        "market": "マーケット概況",
        "platform": "取引所",
        "manyEmpty": "ロング・ショート",
        "hyperliquid": "Hyperliquidクジラ監視",
        "hyperliquidDetails": "Hyperliquidポジション",
        "whale": "大口投資家・保有量",
        "burst": "清算データ",
        "calendar": "経済カレンダー",
        "burstHeatmapDetails": "清算ヒートマップ",
        "burstCoinStatisticsDetails": "通貨別清算統計",
        "rate": "資金調達率",
        "application": "アプリ",
        "publicChain": "ブロックチェーン",
        "newChain": "新規トークン",
        "inscription": "インスクリプション",
        "consult": "ニュース",
        "solswap": "トークン交換",
        "my": "アカウント",
        "signIn": "毎日チェックイン",
        "contractCheck": "コントラクト確認",
        "userHitNewRobotInfo": "トークン取引",
        "calendarDetail": "経済指標の詳細",
        "consultDetails": "記事詳細",
        "newCoinDetails": "新規トークン詳細",
        "firmOffer": "ライブ取引"
    }
},
  common: {
    empty: 'データなし',
    listLoading: '読み込み中...',
    listNoMore: 'もうない',
    tenThousand: "万",
    hundredMillion: "億",
    copy: 'クローン',
    copySuccess: 'コピーが成功しました！',
    sendSuccess: '無事送信されました！',
    confirmText: '確認する',
    cancelText: 'キャンセル',
    contact: 'お問い合わせ',
    privacy: "プライバシーポリシー"
  },
  contact: {
    title: 'お問い合わせ',
    info1: 'TokenTrend',
    info2: 'メール:',
  },
  homeNav: {
    market: '引用',
    platform: 'プラットホーム',
    manyEmpty: 'ロングショート',
    whale: '鯨',
    burst: '清算',
    rate: 'レート',
    calendar: 'カレンダー',
    inscription: '碑文',
    application: '応用',
    searchPlaceholder: '住所または通貨のクエリ',
    searchTitle1: '契約',
    searchTitle2: '通貨',
    searchList1: 'オンチェーンのトランザクション量',
    searchList2: '循環量',
    searchNoResult: 'まだ検索結果がありません',
    historyTitle: '履歴検索履歴'
  },
  calendar: {
    title: 'カレンダー',
    tit1: '重要のみ表示',
    tit2: '経済データ',
    tit3: 'イベント',
    week0: '日曜日',
    week1: '月曜日',
    week2: '火曜日',
    week3: '水曜日',
    week4: '木曜日',
    week5: '金曜日',
    week6: '土曜日',
    tab1: 'データ/時間',
    tab2: '前回値/予測',
    tab3: '重要度/発表',
    event1: '国/時間',
    event2: 'イベント/重要度',
  },
  calendar_details: {
    label1: '最新発表',
    label2: '実績値',
    label3: '予想値',
    label4: '前回値',
    label5: '次回発表日時',
    label6: '発表頻度',
    label7: '重要度',
    label8: 'データ解説',
    label9: '市場への影響',
    label10: '統計方法',
    label11: '発表機関',
    label12: '過去のデータ',
    label13: '1年',
    label14: '2年',
    label15: '5年',

"title": "経済イベントの詳細"
},
  footerNav: {
    publicChain: 'パブリックチェーン',
    newChain: '新チェーン',
    inscription: '碑文',
    smartMoney: '賢いお金',
    consult: 'ニュース',
    calendar: 'カレンダー',
    my: '私の',
  },
  login: {
    title: 'ログイン',
    enterUserName: 'メールアドレス/ユーザー名を入力してください',
    enterPassword: 'パスワードを入力してください',
    enterLogin: 'ログイン',
    loginTip: 'ログイン...',
    forgotPassword: 'パスワードを忘れた',
    register: 'アカウント登録',
  },
  register: {
    title: '登録する',
    enterUserName: 'ユーザー名',
    enterPassword: 'パスワード',
    enterEmail: 'Eメール',
    enterCode: '電子メール認証コード',
    inviteCode: '招待コード（オプション）',
    sendEmailCode: '確認コードを送信してください',
    enterUserNameErr: 'ユーザー名を入力してください',
    enterUserNameErr2: 'ユーザー名は 6 ～ 16 文字の文字または数字で構成されます',
    enterPasswordErr: 'パスワードを入力してください',
    enterPasswordErr2: 'パスワードは8～18文字の英字、数字、特殊記号で構成されています',
    enterEmailErr: 'メールアドレスを入力してください',
    enterEmailErr2: '正しいメールアドレスを入力してください',
    enterCodeErr: 'メール認証コードを入力してください',
    enterRegister: '登録する',
    registerSuccess: '登録が成功しました。ログイン ページにリダイレクトされます...',
    toLogin: 'すでにアカウントをお持ちですか？直接ログインしてください',
    emailCodeTip: '受信トレイにメールが届いていない場合は、迷惑メールと誤判定されている可能性があります。メールボックスのゴミ箱に行って確認してください.'
  },
  userDelete: {
    title: "アカウント削除",
    enterUserName: "ユーザー名",
    enterPassword: "パスワード",
    enterEmail: "メールアドレス",
    enterCode: "メール認証コード",
    sendEmailCode: "認証コードを送信",
    enterUserNameErr: "ユーザー名を入力してください",
    enterPasswordErr: "パスワードを入力してください",
    enterEmailErr: "メールアドレスを入力してください",
    enterCodeErr: "メール認証コードを入力してください",
    enterRegister: "削除を確認",
    registerSuccess: "削除成功、ログインページに移動します...",
  },
  forgotPassword: {
    title: 'パスワードを忘れた',
    enterEmail: 'Eメール',
    enterCode: '電子メール認証コード',
    sendEmailCode: '確認コードを送信してください',
    enterEmailErr: 'メールアドレスを入力してください',
    enterEmailErr2: '正しいメールアドレスを入力してください',
    enterCodeErr: 'メール認証コードを入力してください',
    enterPassword: '新しいパスワード',
    enterPasswordErr: '新しいパスワードを入力してください',
    enterPasswordErr2: 'パスワードは8～18文字の英字、数字、特殊記号で構成されています',
    enterBtn1: 'キャンセル',
    enterBtn2: '確認する',
    forgotPasswordSuccess: '変更が成功しました。ログイン ページにリダイレクトされます...'
  },
  coinDetails: {
    title: "コインの詳細",
    tab1: '取引データ',
    tab2: '通貨情報',
    topInfo1: "24H変動率",
    topInfo2: "24H最高価格",
    topInfo3: "24H最低価格",
    topInfo4: "取引量",
    topInfo5: "24H取引額",
    topInfo6: "24H始値",
    topInfo7: "史上最安値",
    bottomInfo1: "コイン",
    bottomInfo2: "フルネーム",
    bottomInfo3: "公式サイト",
    bottomInfo4: "史上最高価格",
    bottomInfo5: "史上最安価格",
    bottomInfo6: "流通量",
    bottomInfo7: "発行総量",
    bottomInfo8: "最大供給量",
    bottomInfo9: "上場日",
    bottomInfo10: "Telegram",
    bottomInfo11: "ホワイトペーパーリンク",
    bottomInfo12: "人気ランキング",
    bottomInfo13: "時価総額ランキング",

"trade_txt1": "資金フロー",
"trade_txt2": "ポジション分析",
"trade_txt3": "ロング・ショート比率",
"trade_txt4": "大口保有者のポジション",
"trade_txt5": "大口保有者の流動性",
"trade_txt6": "大口保有者の取引",
"trade_txt7": "大口保有者のポジション分布"
},
  coinTrade: {
    title1: '資金流向分析',
    title2: '24時間資金純流入',
    title3: '5日間の主力純流入',
    title4: 'レバレッジ貸借残高増加率',
    title5: 'レバレッジロング・ショート比率',
    title6: 'クロスマージン貸借比率',
    tableTh11: '注文',
    tableTh12: '購入',
    tableTh13: '売却',
    tableTh14: '純流入',
    tableTh15: '大口注文',
    tableTh16: '中口注文',
    tableTh17: '小口注文',
    tableTh18: '合計',
    chart11: '大口買い注文',
    chart12: '中口買い注文',
    chart13: '小口買い注文',
    chart14: '大口売り注文',
    chart15: '中口売り注文',
    chart16: '小口売り注文',
  },
  insdetail: {
    title: '刻印詳細',
    topInfo1: '時価総額',
    topInfo2: '総取引額',
    topInfo3: '24時間取引額',
    topInfo4: '保有者数',
    topInfo5: '取引件数',
    topInfo6: 'メモリプール内',
    topInfo7: '進捗状況',
    bottomInfo1: '刻印名',
    bottomInfo2: '総供給量',
    bottomInfo3: 'デプロイ刻印 ID',
    bottomInfo4: '番号',
    bottomInfo5: '1回の鋳造上限',
    bottomInfo6: '作成者',
    bottomInfo7: '最終刻印番号',
    bottomInfo8: '精度',
    bottomInfo9: '作成日時',
    tab1: '取引履歴',
    tab2: '概要',
    cycle1: '24時間',
    cycle2: '7日間',
    cycle3: '30日間',
  },
  swap: {
    title: 'スワップ',
        pay: '支払う数量',
        receive: '受取予定数量',
        reverse: '交換方向を切り替える',
    title1: 'スワップ',
    title2: 'ウォレットを接続',
    title3: 'ウォレットを切断',
    title4: '戻る',
    title5: 'スリッページ',
    title6: 'ガス料金',
    title7: 'スワップ',
    title8: '残高不足',
    title9: '参考為替レート',
    msg1: 'ウォレットが接続されました',
    msg2: 'ウォレットが切断されました',
    msg3: '有効な金額を入力してください',
    msg4: 'まずウォレットを接続してください',
    msg5: '取引を署名するためにOKXウォレットを開いてください',
    msg6: 'スワップが正常に完了しました！',
  },
  newCoinDetails: {
    topInfo1: '循環',
    topInfo2: '循環率',
    topInfo3: '販売数量',
    topInfo4: '発行総額',
    topInfo5: '24時間増加',
    topInfo6: '最新の価格',
    topInfo7: 'オファー価格',
    topInfo8: '先行販売時間',
    topInfo9: 'コイン上場プラットフォーム',
    topInfo10: '売上高に占める割合',
    topInfo11: '直接リンク',
    listTitle: '市場',
    list1: '取引プラットフォーム',
    list2: 'コインペア',
    list3: '24時間取引高',
    list4: '24H トランザクション量 ($)',
    list5: '割合',

"title": "新規トークンの詳細"
},
  platformDetails: {
    title: 'プラットフォームの詳細',
    volumn24h: '24時間取引量',
    title1: '導入',
    content1: '設立：',
    content2: '登録：',
    content3: 'KYC検証',
    content4: '量子化インターフェイス',
    content5: '資産',
    content6: '取引ペアの数量',
    content7: '公式ウェブサイト',
    isTrue: 'はい',
    isFalse: 'いいえ',
    title2: 'トランザクションサポート',
    content8: 'スポット取引',
    content9: '契約取引',
    content10: 'OTC',
    content11: '法定通貨取引',
    title3: '関連リンク',
    content12: 'フェイスブック',
    content13: 'ツイッター',
    content14: 'レディット',
    content15: '電報',
  },
  topHome: {
    marketSentiment: '市場心理',
        sentimentDetails: '詳細を見る',
        sentimentUnavailable: 'データなし',
        sentimentIndexBlock1: 'センチメントインデックス',
    sentimentIndexBlock1_1: '極度のパニック',
    sentimentIndexBlock1_2: 'パニック',
    sentimentIndexBlock1_3: '中性',
    sentimentIndexBlock1_4: 'よく深い',
    sentimentIndexBlock1_5: '極度の貪欲さ',
    sentimentIndexBlock2: 'BTC ポジションのロングとショート',
    sentimentIndexBlock2_1: '強気の優位性',
    sentimentIndexBlock2_2: 'ショートアドバンテージ'
  },
  market: {
    tabs1: '人気',
    tabs2: '上昇率',
    tabs3: '下落率',
    tabs4: '新しいコイン',
    tabs5: '急騰',
    tabs6: '時価総額',
    tabs7: '取引高',
    popularTh1: "コイン/24H取引量",
    popularTh2: "価格/24H取引高",
    popularTh3: "24H変動",
    newCoinTh1: "コイン/上場時間",
    newCoinTh2: "価格/24H取引高",
    newCoinTh3: "24H変動/取引量",
    marketTh1: "コイン/時価総額",
    marketTh2: "価格/24H取引高",
    marketTh3: "24H変動/取引量"
  },
  platform: {
    tabs1: 'グローバル取引所資産ランキング',
    exchangeTableTh1: 'プラットホーム',
    exchangeTableTh2: '「資産」',
    exchangeTableTh3: '公式ウェブサイト',
  },
  manyEmpty: {
    overviewHint: "取引量・口座・ポジションからロングとショートの変化を確認。",
    topTraders: "大口トレーダー",
    latestRatio: "最新ロング/ショート比率",
    balanced: "均衡",
    longBias: "ロング優勢",
    shortBias: "ショート優勢",
    interval: "時間足",
    chartView: "チャート表示",
    shareView: "構成比",
    loading: "読み込み中…",
    failed: "読み込めませんでした",
    noData: "該当するデータがありません",
    retry: "再試行",
    touchHint: "チャートを長押しで詳細表示",

    title1: '取引量比',
    title2: '人数比',
    title3: 'アカウント比',
    title4: '保有量比',
    progress1: 'ロング：',
    progress2: 'ショート：',
    tableTh1: '取引所',
    tableTh2: '比率',
    tableTh3: 'ロング%',
    tableTh4: 'ショート%',
    msg1: '比率',
    msg2: 'ロング',
    msg3: 'ショート',
    msg4: '人数比',
    msg5: 'ロング人数',
    msg6: 'ショート人数',
    msg7: 'アカウント比',
    msg8: 'ロングアカウント',
    msg9: 'ショートアカウント',
    msg10: '保有量比',
    msg11: 'ロング保有',
    msg12: 'ショート保有',
  },

  whale: {
    holdingsTitle: 'グレースケール位置リスト',
    holdingsTitle2: '更新時間:',
    holdingsTh1: '位置の変更',
    holdingsTh1_1: '1日',
    holdingsTh1_2: '7日',
    holdingsTh1_3: '30日',
    holdingsTh2: 'プレミアム料金',
    holdingsTh3: 'コインの保有枚数',
    holdingsTh4: '位置の値',
    contractTitle: '契約ポジションの合計',
    contractTh1: '交換',
    contractTh2: '位置の値($)',
    contractTh3: 'ポジションの数',
    contractTh4: '15分変更',
    contractTh5: '1日の変更',
    exchangeTitle: '為替残高リスト',
    exchangeTh1: '交換',
    exchangeTh2: 'ウォレットの数',
    exchangeTh3: '24時間変更',
    exchangeTh4: '変化の7日間',
    exchangeTh5: '30日間の変化',
    statistics1: '時価総額の合計',
    statistics2: '24時間取引高',
    statistics3: '24時間最低価格',
    listRight1: '転送アドレス:',
    listRight2: '転送アドレス:',
    listRight3: '払込金額：',
  },
  autosearch: {
    msg: '検索',
    msg1: 'キーワードを入力してください(取引所、通貨名)',
    msg2: 'クリア',
    msg3: 'これ以上のデータはありません',
    msg4: '関連するデータが見つかりませんでした',
  },
  burst: {
    explorerView: "清算チャート",
    explorerheatmap: "ヒートマップ",
    explorermap: "清算マップ",
    explorerOtherLeverage: "その他のレバレッジ",
    explorerCumulativeLong: "累積ロング清算量",
    explorerCumulativeShort: "累積ショート清算量",
    explorerClose: "閉じる",
    explorerExpand: "拡大",
    explorerCoin: "コイン",
    explorerScope: "取引所",
    explorerPair: "取引所",
    explorerAll: "全市場",
    explorerEstimate: "推定清算ゾーン",
    explorerPrice: "最新参考価格",
    explorerAbove: "上方の主要ゾーン",
    explorerBelow: "下方の主要ゾーン",

    currentPrice: '現在の価格：',
    liquidationTip1: '累計マルチシングル清算強度',
    liquidationTip2: '積算空単清算強度',
    liquidationTip3: '10 xレバー',
    liquidationTip4: '25 xレバー',
    liquidationTip5: '50 xレバー',
    liquidationTip6: '100 xレバー',
    heatmapTop: 'Binance、Huobi、OKX の 3 つの主要取引所からの包括的なデータ、{0}USDT の最大清算点は {1} 付近にあり、清算価値は {2}USDT です。資本リスクにご注意ください。',
    toBurstHeat: '詳細',
    heatmapMaximum: '清算強度上限',
    heatmapMinimum: '下限',
    heatmapKLine1: 'k線',
    heatmapKLine2: '清算強度',
    heatmapTip1: '価格',
    heatmapTip2: '清算強度',
    kLineTip1: '始値',
    kLineTip2: '終値',
    kLineTip3: '最高価格',
    kLineTip4: '最低価格',
    noLogin: 'ログイン後にヒートマップを表示する',
    toLogin: 'ログインに移動',
    topBlockH4: '1H清算',
    topBlockH41: '4H清算',
    topBlockH42: '12H清算',
    topBlockH43: '24時間清算',
    topBlockP: 'ロングオーダーの割合',
    rankingTitle: '過去 24 時間、清算ランキング:',
    rankingTh1: '取引所',
    rankingTh2: '数量',
    rankingTh3: '清算米ドル',
    rankingTh4: '米ドルロング',
    rankingTh5: '空の注文USD',
    coinStatisticsH4: '各通貨の清算統計',
    coinStatisticsT1: '1H',
    coinStatisticsT2: '4H',
    coinStatisticsT3: '24H',
    exchangeProportionH4: 'ネットワーク全体のすべての取引所で清算されたポジションの割合',
    exchangeProportionT1: '4H',
    exchangeProportionT2: '12H',
    exchangeProportionT3: '24時間',
    heatmapDetailsList1Top: 'ヌル',
    heatmapDetailsList1Bottom: '多くの',
    heatmapDetailsList1: '方向：',
    heatmapDetailsList2: '価格：',
    heatmapDetailsList3: '清算：',
    coinStatisticsDetailsTh1: '通貨',
    coinStatisticsDetailsTh2: '長期注文の清算',
    coinStatisticsDetailsTh3: '短期注文清算',
    coinStatisticsDetailsTh4: '時間',
  },
  rate: {
    title1: "資金費率",
    type1: "ポジション加重",
    type2: "取引額加重",
    price: '価格',
    newTitle: 'Exchangeの現在の調達レート一覧',
    newTableTh1: '通貨',
    newTableTd1: '予測レート',
    tableTh1Old: '交換',
    tableTh2Old: '現在のレート',
    tableTh3Old: '最高レート',
    tableTh4Old: '最低レート',
  },
  application: {
    leftNav1: 'アプリケーション',
    leftNav2: 'ウォレット',
    leftNav3: 'ソーシャル',
    visit: '開く',
    empty: 'まだありません',
    download: 'ダウンロード',
    register: '登録する'
  },
  publicChain: {
        loadFailed: '読み込めませんでした。再試行してください。',
        retry: '再試行',

    tableTh1: 'ペア/時価総額',
    tableTh2: '価格/取引量',
    tableTh3: '変動率/時間',
  },
  inscription: {
    typeAll: 'すべて',
    tableTh1: 'シリアル番号',
    tableTh2: 'トークン名',
    tableTh3: 'ホルダー',
    tableTh4: 'トランザクションの総数',
    tableTh5: '価格',
  },
  smartMoney: {
    swipe1: '賢いお金を使ってもらいましょう',
    swipe2_1: '通貨サークルの初心者向けに特別にカスタマイズされました',
    swipe2_2: '個人投資家が機会をつかむのを支援',
    listTip: '7x24H 監視',
    list1Title: 'トップ 100 高頻度取引',
    list1Msg: '大手パブリックチェーン8社の包括利益/利回り上位100社',
    list2Title: 'セレブのスマートマネー',
    list2Msg: '世界的な有名人/パブリック チェーンの創設者/有名な機関のアドレス追跡',
    list3Title: 'レベル 1 スマートマネー',
    list3Msg: '発行市場でより高い/安定した利益をもたらすスマートマネー',
    list4Title: 'カスタマイズされたスマートマネー',
    list4Msg: 'ユーザーによって追加されたウォレットアドレスを追跡',
  },
  smartMoneyTop100: {
    topTip: '過去 30 日間の主要 DEX の包括的な分析データ。バランスはあくまで参考です！',
    amountUsd: 'トークン総勝率',
    floatProfit: '取引額',
    floatProfitPercent: '変動利益率',
    profit: '利益',
    profitPercent: '収益性',
    collectTo: '収集',
    collectCancel: 'コレクションをキャンセル',
    noLogin: 'ログイン後、世界で最も収益の高いスマート マネーのトップ 100 を表示および追跡できます。',
    toLogin: 'ログインに移動',
  },
  smartMoneyStar: {
    title: 'セレブの賢いお金',
  },
  smartMoneyOneLevel: {
    title: 'レベル 1 のスマートマネー',
  },
  smartMoneyCustom: {
    title: 'カスタマイズされたスマートマネー',
    addName: '名前:',
    addNameRules: '名前を入力してください',
    addAddress: 'アドレス:',
    addAddressRules: 'アドレスを入力してください',
    addComment: '備考:',
    addConfirm: '確認',
    addSuccess: '正常に追加されました! ',
    delBtn: '削除',
    delSuccess: '削除に成功しました! '
  },
  smartMoneyDetails: {
    queryTokenAll: 'すべて',
    return: '戻り値',
    dexAddress: 'アドレス:',
    dexHash: 'トランザクション ハッシュ:',
    dexChainName: 'チェーン名:',
    dexTransactionAmount: 'トランザクション値:',
    dexTrackerIn: '契約への転送:',
    dexTrackerOut: '契約の転送:',
    dexTrackerType: '取引方向:',
    dexTrackerTypeCon: '{0}{1} が {2}{3} に変換されました',
    dexTransactionTime: 'トランザクション時間:',
    ordinaryHash: 'トランザクション ハッシュ:',
    ordinaryFrom: '送信者アドレス：',
    ordinaryTo: '受信者アドレス：',
    ordinarySymbol: '通貨名：',
    ordinaryAmount: '転送数量：',
    ordinaryTime: '時間：',
  },
  consult: {
    topNav1: 'ニュース',
    topNav2: 'お知らせ',
    topNav3: 'ニュース',
    detailsShare: '共有:',
    detailsTime: '時間'
  },
  my: {
    headPictureSuccess: '変更に成功しました! ',
    toSignIn: 'サインインに移動',
    wallet: 'ウォレット残高にサインイン',
    details: '詳細',
    memberTitle: 'メンバー センター',
    memberItem1: '契約書チェック',
    memberItem2: 'コインを引き出す',
    memberItem3: 'オンライン顧客サービス',
    memberItem4: '招待リンク',
    installMetaMask: '最初にメタマスクをインストールしてください。 ',
    nav1: 'コレクション',
    nav2: 'トラック',
    nav3: 'チーム',
    nav4: 'フォーラム',
    nav5: 'ツール',
    nav6: '言語',
    nav7: "ログアウト",
    nav8: 'バインドAPI',
    nav9: '新しいロボットを作る',
    nav10: "アカウント削除",
    nav11: "ログアウト"
  },
  signIn: {
    title: '{0} 日間チェックインしました',
    btn: '今すぐサインイン',
    tip1: "プラットフォームを {0} 分間閲覧すると、サインイン特典を受け取ることができます",
    tip2: '(閲覧時間は {0} 分と {1} 秒です)',
    success: 'サインインに成功しました! ',
    recordTitle: 'サインインレコード',
    recordListContent: '時間:',
  },
  signInRecord: {
    title: 'ウォレットの詳細',
    selectAll: '全て',
    typeSelect1: 'サインイン特典',
    typeSelect2: '直接プロモーション特典',
    typeSelect3: 'チームの報酬',
    typeSelect4: '現金引き出し控除を申請する',
    typeSelect5: 'システム拒否の増加',
  },
  contractCheck: {
    riskAssessment: 'リスク評価',
    riskInspection: 'リスク検査',
    enterPlaceholder: '契約アドレスを入力してください',
    enterBtn: 'チェック',
    checkNFT1: ['悪意のある NFT はありません', '悪意のある NFT'],
    checkNFT2: ['オープンソースではない', 'オープンソース'],
    checkNFT3: ['エージェント契約なし', 'エージェント契約'],
    checkNFT4: ['未検証', '検証済み'],
    checkNFT5: ['有名で信頼できるNFTではありません', '有名で信頼できるNFT'],
    checkToken1: ['最大取引額または最大トークン位置を変更する機能はありません', '最大取引額または最大トークン位置を変更する機能はあります'],
    checkToken2: ['所有権は回復できません', '所有権は回復できます'],
    checkToken3: ['コントラクトには非表示の所有者がいません', 'コントラクトには非表示の所有者がいます'],
    checkToken4: ['単一アドレスの最大取引量または最大位置を制限する機能はありません', '最大取引量または単一アドレスの最大位置を制限する機能があります'],
    checkToken5: ['トークンはハニーポットではありません', 'トークンはハニーポットです'],
    checkToken6: ['トークンは分散型取引所では取引できません', 'トークンは分散型取引所では取引できます'],
    checkToken7: ['コントラクトにはトークンを鋳造する機能がありません', 'コントラクトにはトークンを鋳造する能力があります'],
    checkToken8: ['オープンソースではない', 'オープンソース'],
    checkToken9: ['エージェントではありません', 'エージェントです'],
    checkToken10: ['契約所有者はトークン所有者の残高を変更できません', '契約所有者はトークン所有者の残高を変更できます'],
    checkToken11: ['割り当てられたアドレスごとに異なる税率を設定することはできません', '割り当てられたアドレスごとに異なる税率を設定することはできます'],
    checkToken12: ['コントラクトは自己破壊できません', 'コントラクトは自己破壊できます'],
    checkToken13: ['コントラクトにはトランザクション クーリング メカニズムがありません', 'コントラクトにはトランザクション クーリング メカニズムがあります'],
    checkToken14: ['トークンコントラクトを通じて取引を一時停止することはできません', 'トークンコントラクトを通じて取引を一時停止することができます'],
    checkToken15: ['このトークンは有名で信頼できるトークンではありません', 'このトークンは有名で信頼できるトークンです'],
    botToken1: '所有者のアドレス',
    botToken2: '所有者の残高',
    botToken3: '所有者が保有するトークンの割合',
    botToken4: '供給量',
    botNFT1: '総トランザクション量',
    botNFT2: '保有者数',
    botNFT3: '最高価格',
    botNFT4: '24 時間平均価格',
    botNFT5: '24時間最低価格',
  },
  withdrawal: {
    title: 'コインを引き出す',
    titleTip: '出金アドレスはTRON (TRC-20) チェーンのウォレットアドレスでなければなりません。他のチェーンのウォレットアドレスを入力すると、永久に損失が発生し、回復できなくなります。 ',
    withdrawalAddress: 'あなたの引き出しアドレス:',
    inputWithdrawalAddress: '出金アドレスを入力してください',
    number: '数量',
    inputNumber: '数量を入力してください',
    inputNumberErr: '残高が不足しています',
    balance: 'バランス',
    actualReceipt: '実際の領収書:',
    gas: '料金:',
    tip: '最低出金は {0}USDT で、出金手数料は {1}% です。 ',
    confirm: 'OK',
    explain: 'オンライン取引には 0 ～ 2 時間かかります。オンライン確認は含まれていません。',
    submitSuccess: '送信成功'
  },
  withdrawalRecord: {
    title: '貨幣引出記録',
    list1: '住所：',
    list2: 'ネットワーク：',
    list3: '通貨＃ツウカ＃：',
    list4: '数量：',
    list5: '手数料：',
    list6: 'ステータス：',
    list7: '時間:',
    status0: '審査待ち',
    status1: '合格',
    status2: '断る',
  },
  bindingApi: {
    title: 'バインドAPI',
    tip: '取引所のAPI作成にはIPをバインドする必要があります',
    listTitle: 'バインドリスト',
    unBindBtn: '解縛',
    availableBalance: '使用可能残高:',
    bindFrom1: '選択取引所:',
    bindFrom1Err: '取引所を選択してください',
    bindFrom2Err: 'Api key と入力してください',
    bindFrom3Err: 'Secret key と入力してください',
    bindFrom4Err: 'PassPhrase と入力してください(OKX必須)',
    bindFrom5: '備考:',
    bindFrom5Err: 'コメントを入力してください',
    bindSuccess: 'バインド成功',
    unBindSuccess: 'アンバインド成功'
  },
  myAsset: {
    disconnect: '切断する'
  },
  collect: {
    title: '集める',
    amountUsd: '残高',
    floatProfit: '変動利益',
    floatProfitPercent: '変動利益率',
    profit: '利益',
    profitPercent: '利益率',
    cancel: 'コレクションをキャンセル',
    cancelSuccess: 'キャンセルが成功しました! '
  },
  trace: {
    title: '追跡',
    list1: 'パブリックチェーン名:',
    list2: 'トークン名:',
    list3: 'アドレス:',
    listDel: '削除',
    listDelSuccess: '削除に成功しました! '
  },
  team: {
    title: 'チーム',
    topInfo1: '直紹介人数',
    topInfo2: 'チーム人数',
    topInfoUnit: '人',
    tableTh1: 'ユーザー名',
    tableTh2: '登録時間',
    inviteCode: '招待コード',
    empty: 'まだ直紹介のメンバーはいません。招待リンクを共有してください。',
  },
  forum: {
    title: 'フォーラム',
    toForumPublishNoLogin: 'まずログインしてください。その後、公開できます。 ',
    publishTitle: 'フォーラムの公開',
    publishContentPlaceholder: 'コンテンツを入力してください',
    publishSuccess: '正常に公開されました! ',
    publishConfirm: '公開',
    forumList1: '全文',
    detailsTitle: 'フォーラムのテキスト',
    detailsCommentTitle: 'コメント',
    detailsCommentInputPlaceholder: 'コメントの内容を入力してください',
    detailsCommentInputSuccess: '正常に送信されました! ',
    detailsCommentInputBtn: '送信',
  },
  tool: {
    title: '道具',
    tool1: 'BTC企業の地位',
    tool2: 'センチメントインデックス',
    tool3: 'メントグーのモニタリング',
    tool4: '店頭価格',
    tool5: '外部ディスク情報',
    tool6: '大口投資家がポジションを増やす',
    tool7: '大口投資家がポジションを減らす',
    tool8: 'ステーブルコイン',
    tool9: 'ブロックチェーンブラウザ',
  },
  toolCompanyHoldings: {
    title: 'BTC 保有機関',
    titleSub1: 'グローバル企業のBTCポジションデータ',
    globalDataT1: 'BTC 持株会社',
    globalDataD1: 'ホーム',
    globalDataT2: '会社の総ポジション',
    globalDataD2: '過去 7 日間の変更:',
    globalDataT3: 'ポジションの合計値',
    globalDataD3: '過去 7 日間の変更:',
    globalDataT4: 'BTC 市場価値の合計を占めるポジション',
    globalDataD4: '7 日前の割合:',
    titleSub2: 'BTC 持株会社',
    listTh1_1: '位置値 ($)/',
    listTh1_2: 'BTCの時価',
    listTh2_1: 'ポジション BTC/',
    listTh2_2: '過去 7 日間の順位の変更',
    listTh3_1: '総保有コスト/',
    listTh3_2: '平均コスト ($)',
  },
  toolSentimentIndex: {
    title: 'センチメントインデックス',
    titleSub1: 'パニックと貪欲のインデックス',
    titleSub1_1: 'BTC と重要な主流通貨のパニックと強欲指数',
    gauge1: '極度のパニック',
    gauge2: 'パニック',
    gauge3: '中性',
    gauge4: 'よく深い',
    gauge5: '非常に貪欲な',
    titleSub2: '歴史的なインデックス',
  },
  toolMTGoxMonitor: {
    title: 'メントウゴウモニタリング',
    titleSub1: 'メントウグー (MTGox) BTC コールド ウォレット',
    topLabel1: '元の保有BTC総量',
    topLabel1Span: '元の値',
    topLabel2: 'BTC 残高の合計',
    topLabel2Span: '現在の値',
    topLabel3: 'BTC 変更額を保持',
    titleSub2: 'BTC コールドウォレット送金記録',
    tableTh1: 'トランザクション時間',
    tableTh2: 'コールドウォレットアドレス',
    tableTh3: '送金BTC量',
  },
  toolOutsidePrice: {
    title: '店頭価格',
    th1: '交換',
    th2: '平均取引価格',
    th3: 'プレミアム',
  },
  toolOutsideDisk: {
    title: '外部ディスク情報',
    itemTitleSpan: '更新',
    itemTitle2: '開店時間:',
    beijingTime: '北京時間',
    nextDay: '翌日',
    itemInfo1: '昨日受け取りました',
    itemInfo2: '本日営業',
    itemInfo3: '本日の取引高',
    itemInfo4: '今日の最高値',
    itemInfo5: '今日の最低値',
    itemInfo6: '過去 1 年間の最高値',
    itemInfo7: '過去 1 年間で最低',
    names: {
      BRENT: 'ブレント原油',
      DJI: 'ダウ平均',
      HKHSI: 'ハンセン指数',
      INX: 'S&P 500',
      IXIC: 'ナスダック総合',
      N225: '日経225',
      SH000001: '上海総合',
      SH000300: 'CSI 300',
      WTI: 'WTI原油',
      XAU: 'ロンドン金（スポット）',
    },
  },
  toolLargeIncrease: {
    title: '大口投資家はポジションを増やす',
    tableTh1: '通貨',
    tableTh2: '24 時間の浮き沈み',
    tableTh3: '24H 位置比率',
    tableTh4: '週次ポジション比率',
    tableTh5: '月次ポジション比率',
    tableTh6: 'グローバルインデックス ($)',
    tableTh7: '上位 10 位の割合',
    tableTh8: '上位 20 位の割合',
    tableTh9: '上位 50 位の割合',
    tableTh10: '上位 100 位の割合',
  },
  toolLargeDecrease: {
    title: '大口投資家はポジションを減らす',
    tableTh1: '通貨',
    tableTh2: '24 時間の浮き沈み',
    tableTh3: '24H 位置比率',
    tableTh4: '週次ポジション比率',
    tableTh5: '月次ポジション比率',
    tableTh6: 'グローバルインデックス ($)',
    tableTh7: '上位 10 位の割合',
    tableTh8: '上位 20 位の割合',
    tableTh9: '上位 50 位の割合',
    tableTh10: '上位 100 位の割合',
  },
  toolStableCoin: {
    title: 'ステーブルコイン',
    UsdTopInfo1: 'USDT 平均店頭価格',
    UsdTopInfo2: '米ドル為替レート',
    UsdTopInfo3: 'USDT プレミアム レート',
    UsdTitleSub1: 'USDT 関連の指数トレンド',
    UsdIndexQuery1: '7 日間',
    UsdIndexQuery2: '30 日',
    UsdTitleSub2: 'USDT プレミアム関連のトレンド',
    relatedTitleSub1: 'ステーブルコインの概要',
    relatedTopTh1: '通貨',
    relatedTopTh2: '平均場外価格（円）／プレミアム料金',
    relatedTopTh3: '電流循環',
    relatedTitleSub2: 'ステーブルコインの流通',
    relatedQuery1: '30日',
    relatedQuery2: 'ほぼ1年',
    relatedTitleSub3: 'ステーブルコインの流通割合',
    relatedTitleSub4: 'ステーブルコインチェーン上での発行',
    relatedBottomListH4_1: '追加発行',
    relatedBottomListH4_2: '破壊する',
    relatedBottomListHash: 'トランザクションハッシュ：',
  },
  toolBlockChainBrowser: {
    title: 'ブロックチェーンブラウザ',
  },
  firmOffer: {

    titleLabel0: '契約アドレス：',
    titleLabel1: '保有アドレス数',
    titleLabel2: 'ユニーク取引アドレス数',
    titleLabel3: '取引件数',
    titleLabel4: '取引額',
    titleLabel5: '流動性',
    titleLabel6: '時価総額',
    titleLabel7: '作成日時',
    titleLabel8: 'ロック総時価総額',
    tabs1: '取引履歴',
    tabs2: 'プール変動',
    tabs3: '保有アドレス',
    tabs4: '資金',
    transactionTh1: '時間',
    transactionTh2: '価格($)',
    transactionTh3: '取引量($)',
    transactionTh4: '数量',
    transactionTh5: 'ウォレットアドレス',
    transactionAddTrace: 'このウォレットアドレスを追跡しますか？',
    transactionAddTraceSuccess: '追加成功！',
    tag1: '買 入',
    tag2: '売 出',
    tag3: '増加',
    tag4: '減少',
    poolTip: 'デフォルトで最初のプールデータを表示',
    poolTh1: '時間',
    poolTh2: '種類',
    poolTh3: '取引量($)',
    poolTh4: '数量',
    poolTh5: 'ウォレットアドレス',
    poolCurrent: '総アドレス数',
    Explain1: '総アドレス数：',
    Explain2: 'トップ10の割合：',
    Explain3: 'スナイパー数：',
    Explain4: '疑わしい保有アドレス数：',
    positionTh1: 'ランク',
    positionTh2: 'ウォレットアドレス',
    positionTh3: '保有割合',
    positionTh4: '数量',
    positionTh5: '24時間変動',
    positionTh6: 'ブロック情報',
    financeType1: 'トップ買い手',
    financeType2: 'トップ売り手',
    financeTh1buy: '純買入',
    financeTh1sell: '純売出',
    financeTh2buy: '買入額($)',
    financeTh2sell: '売出額($)',
    financeTh3: 'ユーザー',
    addTrace: '現在のアドレスを追跡しますか？',
    addTraceSuccess: '追加成功！',

"title": "トークン詳細"
},

  smartMoneySmall: {
    cycle1: '1分',
    cycle2: '5分',
    cycle3: '30分',
    cycle4: '1時',
    cycle5: '4時',
    cycle6: '1日',
    klineIndicator1: '購入',
    klineIndicator2: '売り',
    tableTh1: '購入数量',
    tableTh2: '購入金額',
    tableTh3: '販売数量',
    tableTh4: '販売額',
    tableTh5: '変動利益',
    tableThAddress: '住所：',
    detailsReturn: '戻り値リスト',
    detailsAddress: 'アドレス:',
    detailsTokenAddress: 'トークンアドレス:',
    detailsChainName: 'チェーン名:',
    detailsTrackerType: '取引方向:',
    detailsTrackerTypeVal1: '購入',
    detailsTrackerTypeVal2: '販売',
    detailsAmount: '購入数量:',
    detailsAmountUsd: '購入金額USD:',
    detailsTransactionTime: 'トランザクション時間:',
    detailsHash: 'トランザクション ハッシュ:',
  },
  hitNewRobot: {
    title: '新しいロボット',
    topImg1: '科学技術の未来をリードするスマートな時代',
    topImg2: '新しいロボット',
    topImg3: '9月30日',
    topImg4: '正式に発売されました',
    topImg5: 'ルールを表示>>',
    type1: '新しい交換リスト',
    hitNewlistTh1: 'トークン情報',
    hitNewlistTh2: 'トークン価格',
    hitNewlistTh3: 'プール割合',
    hitNewlistTh4: '初期/残り',
    hitNewlistTh5: '時間',
    createBtn: '作成',
    createTitle: 'ロボットの作成',
    createLabel1: 'Exchange 名:',
    createLabel2: '通貨ペアの名前:',
    createLabel3: 'リスト時間:',
    createLabel7: '使用可能残高：',
    createLabel4: '購入予定数量:',
    createLabel5: '推定購入価格:',
    createLabel6: '買い占め時間：',
    createLabel4Err: '推定購入数量を入力してください',
    createLabel5Err: '推定購入価格を入力してください',
    createLabel6Err: '買占め時間を選択してください',
    createLabel6Select1: '年月日の選択',
    createLabel6Select2: '選択時分秒',
    createTip: '購入価値は>=10 USDT',
    createSuccess: '作成に成功しました! ',
    type2: 'ロボットリスト',
    robotListStatus1: '実行予定',
    robotListStatus2: '終了',
    robotListBinanceStatus1: '請求書作成に成功しました',
    robotListBinanceStatus2: '請求に失敗しました',
    robotList1: '実行時間:',
    robotList2: 'ロボットをキャンセル',
    robotList3: 'コインペア',
    robotList4: '価格',
    robotList5: '数量',
    robotCancel: 'キャンセル成功',
  },
  hitNewRobotInfo: {
    title: '取引',
    title2: '取引履歴'
  },
  hitNewRobotRule: {
    title: 'デジタル通貨新ロボットモジュールのご紹介',
    h2_1: '主な利点：',
    label1_1: '効率的なアルゴリズム：',
    label1_2: '深い統合：',
    label1_3: 'ビッグデータ処理：',
    label1_4: '賢い戦略：',
    label1_5: '安全：',
    label1_6: '自動取引：',
    label1_7: 'エクスペリエンスの最適化：',
    p1_1: '内蔵の効率的なアルゴリズム、ミリ秒レベルの取引決定、市場ダイナミクスの正確な把握。',
    p1_2: 'Binance、HTX、OKX などの主流の取引所 API を統合して、包括的で正確なデータを確保します。',
    p1_3: 'Apache Kafka と Flink テクノロジーを利用して、リアルタイムで市場データを収集および処理します。',
    p1_4: 'TensorFlow または PyTorch フレームワークと組み合わせて、履歴データとトレンドを使用して新しい戦略を最適化します。。',
    p1_5: '分散アーキテクチャと複数の暗号化テクノロジーにより、ユーザー データとトランザクションのセキュリティを確保します。',
    p1_6: '将来的には、DEX自動取引と効率的な資産管理を実現するために、スマートコントラクトとクロスチェーン技術を検討していきます。。',
    p1_7: 'インターフェイスとインタラクションのデザインを継続的に最適化し、直感的なデータ視覚化ツールを提供し、ユーザー エクスペリエンスを向上させます。。',
    h2_2: 'メンバーシップのアップグレード基準：',
    label2_1: 'v0 → v1：',
    label2_2: 'v1 → v2：',
    label2_3: 'v2 → v3：',
    label2_4: 'v3 → v4：',
    label2_5: 'v4 → v5：',
    label2_6: 'v5 → v6：',
    label2_7: 'v6 → v7：',
    p2_1: '3名を直接推薦し、チームは100名に到達。',
    p2_2: '5人を直接推薦し、チームは200人に到達。',
    p2_3: '直接昇格したのは 5 人で、そのうち 2 人が v2 に到達しました。',
    p2_4: '直接昇格したのは 5 名で、そのうち 2 名が v3 に到達しました。',
    p2_5: '直接推薦した 5 人のうち 2 人が v4 に到達。',
    p2_6: '直接昇格したのは 5 人で、そのうち 2 人が v5 に到達しました。',
    p2_7: '直接昇格は5名、うち2名がv6に到達。',
    h2_3: 'ロボットの流通基準：',
    label3_1: 'V1',
    label3_2: 'V2',
    label3_3: 'V3',
    label3_4: 'V4',
    label3_5: 'V5',
    label3_6: 'V6',
    label3_7: 'V7',
    p3_1: 'ロボットを1体入手。',
    p3_2: 'ロボットを3体入手。',
    p3_3: 'ロボットを5体入手。',
    p3_4: 'ロボットを6体入手。',
    p3_5: 'ロボットを7体入手。',
    p3_6: 'ロボットを9体入手。',
    p3_7: '10 体のロボットを獲得し、さらに 5 体をプレゼント、合計 15 体のロボットになります。',
    h2_4: 'ロボットの効果的な動作条件：',
    label4_1: '継続的なチェックイン：',
    label4_2: '発動条件：',
    label4_3: 'チェックインが中断されました：',
    p4_1: 'メンバーはロボットが効果的に動作していることを確認するために毎日チェックインし続ける必要があります。',
    p4_2: '継続的にサインインしているメンバーのみが新しいサービスをアクティブ化できます。',
    p4_3: '当日にサインを見逃した場合、翌日には新しいロボットの動作が停止し、サインインが再開された翌日の0:00に自動的に起動します。。',
    h2_5: '要約する：',
    p5: 'このプラットフォームのデジタル通貨新規作成ロボットモジュールは、効率的なアルゴリズムとインテリジェントな戦略を通じて、自動化された効率的かつ安全な新規作成サービスを会員に提供します。テクノロジーの継続的な進歩により、当社は今後もユーザーエクスペリエンスを最適化し、より多様な新しいオプションを拡大し、会員の資産価値の向上を支援していきます。。'
  },
  invite: {
    title: '友達を招待する',
    info1: '友達を登録/チームに招待する',
    info2: 'ロボット/プロモーション特典を開封するチャンスがあります',
    info3: 'こんにちは！TokenTrend プラットフォームへようこそ',
    info4: '通貨サークルの初心者向けに特別にカスタマイズされた新しいツールは、ワンクリックで使用できます',
    btn: '招待リンクをコピー'
  }
,
    hyperliquid: {
        searchPlaceholder: 'ウォレットアドレスを入力してポジションを検索...',
        searchBtn: '検索',
        title: 'クジラポジション監視',
        dataCount: '大口ポジション {0} 件',
        long: 'ロング',
        short: 'ショート',
        cross: 'クロス',
        isolated: '隔離',
        positionValue: 'ポジション価値',
        positionSize: 'ポジションサイズ',
        entryPrice: '建玉価格',
        markPrice: 'マーク価格',
        unrealizedPnl: '未実現損益',
        noData: 'データなし',
        enterAddress: 'ウォレットアドレスを入力してください',
        enterValidAddress: '有効なウォレットアドレスを入力してください',
        copyAddress: 'アドレスをコピー',
        whale: 'クジラ',
        explorer: 'エクスプローラー',
        accountTotalValue: '口座総額',
        perpetual: '無期限',
        freeMarginAvailable: '利用可能証拠金',
        withdrawable: '出金可能',
        totalPositionValue: 'ポジション総額',
        leverageRatio: 'レバレッジ比率',
        marginUsed: '使用証拠金',
        usedRatio: '使用率',
        perpTotalValue: '無期限ポジション総額',
        positionsCount: '{0} ポジション',
        avgMarginUsedRatio: '平均証拠金使用率',
        directionBias: '方向バイアス',
        longExposure: 'ロングエクスポージャー',
        shortExposure: 'ショートエクスポージャー',
        positionDistribution: 'ポジション分布',
        longValue: 'ロング価値',
        shortValue: 'ショート価値',
        roe: 'ROE',
        upnl: '未実現損益',
        perpPositions: '無期限ポジション ({0})',
        symbol: '銘柄',
        entryAvgPrice: '平均建玉価格',
        margin: '証拠金',
        fundingCost: '資金調達コスト',
        noPositions: 'ポジションなし',
        userAddressRequired: 'ユーザーアドレスは必須です',
        addressCopied: 'アドレスをコピーしました',
        copyFailed: 'コピーに失敗しました',
        bullish: '強気',
        bearish: '弱気',
        neutral: '中立'
    },
"burstHeatmapDetails": {"title":"清算ヒートマップ"},
"burstCoinStatisticsDetails": {"title":"銘柄別清算統計"},
"forumPublish": {"title":"投稿を作成"},
"forumDetails": {"title":"コミュニティ投稿"},
"consultDetails": {"title":"記事の詳細"}
}
